import { ResolvedSite } from "@libry-content/common";

export const isUrlInternal = (site: ResolvedSite | undefined, url: string | undefined): boolean =>
  !!site?.domain && !!url && url?.includes(site.domain);
